/**
 * @class 基础类
 */
export default class Basic {
  init(util) {
    if (util) util.build(this.settings, this)
  }

  update(fn) {
    this._update = fn
  }

  trimDropWidth(unit, drop) {
    const wt = unit.width()
    drop.css({ 'min-width': wt })
  }

  hasLocation(unit, drop, anchor) {
    if (drop.css('display') === 'none') return
    const { top, left } = unit.offset()
    // 计算宽度
    const width = unit.outerWidth()
    const thin = $(anchor).width() || 0
    const sl = $(anchor).scrollLeft() || 0
    const dw = drop.width()
    let leftReal = left
    let rightReal = 'auto'
    if (left + width + dw > thin + sl) {
      leftReal = 'auto'
      rightReal = 25
    }
    // 计算高度
    const height = unit.outerHeight()
    const long = $(anchor).height() || 0
    const st = $(anchor).scrollTop() || 0
    const dh = drop.height()
    if (top + height + dh < long + st) {
      const dt = top + height
      drop.css({
        top: dt,
        left: leftReal,
        right: rightReal,
        'z-index': 9999,
      })
      drop.attr('x-placement', 'bottom-start')
    } else if (top - dh > 0) {
      const dt = top - dh - 18
      drop.css({
        top: dt,
        left: leftReal,
        right: rightReal,
        'z-index': 9999,
      })
      drop.attr('x-placement', 'top-start')
    } else {
      const dt = (long + st - dh) / 2
      drop.css({
        top: dt,
        left: leftReal,
        right: rightReal,
        'z-index': 9999,
      })
      drop.attr('x-placement', 'bottom-start')
    }
    $('body').append(drop)
  }

  get symbol() {
    return this.settings.symbol || ''
  }
}
